module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAsklEQVQ4jdWVMRKEIAxFv7Sp0+f+p0pPnRqL3TjgkqzMroV/xkF8wkh4KkSkAfg4mLkx8zITkba9T9BHVYd+zzPmvHjHzKCqMLPhRhG5zDzHpLXWoe2zyo5JmXlo+6yyDa8CT2vjiWoajsl2Mdv9zJqCIGYGIpoyIho25pzp8rMlZtyvFweRNv7UZ22ycQ9X6teahkpl2nzTLVQq0ybTDbjpjZoq1WdFt4cq9e8vP+74R+3ExyiQ5PrpzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/assets/img/About_back.png
// module id = ../../../../../src/assets/img/About_back.png
// module chunks = main